import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

import {
  CheckerFinding,
  CheckerPlugin,
  CheckerPluginChecks,
  CheckerPluginFinding,
  CheckerStatus,
} from '../checker.model';
import {
  GithubGlobalCheckerCheck,
  GithubStatusSummaryResponse,
  statusEmoji,
} from './github-checker.model';

@Injectable()
export class GithubCheckerPlugin implements CheckerPlugin {
  static GlobalChecks(
    ...checks: GithubGlobalCheckerCheck[]
  ): CheckerPluginChecks {
    return { plugin: this, checks };
  }

  constructor(private http: HttpClient) {}

  async globalCheck(
    check: GithubGlobalCheckerCheck,
  ): Promise<CheckerPluginFinding> {
    let finding: CheckerFinding = {
      status: CheckerStatus.warn,
      title: 'Github Plugin',
      message: `Unexpected global check id: ${check.id}`,
    };
    if (check.id === 'status') {
      finding = await this.checkGithubStatus();
    }
    return { check, finding };
  }

  async pageCheck(
    url: string,
    params: Record<string, any>,
    check: any,
  ): Promise<CheckerPluginFinding> {
    return { check, finding: null };
  }

  async checkGithubStatus(): Promise<CheckerFinding> {
    let data: GithubStatusSummaryResponse;
    try {
      data = await firstValueFrom(
        this.http.get<GithubStatusSummaryResponse>(
          `https://www.githubstatus.com/api/v2/summary.json?t=${Date.now()}`,
        ),
      );
    } catch (e) {
      return {
        status: CheckerStatus.error,
        title: `Github Status`,
        message: `API is not responsive`,
      };
    }

    const warns = {};
    for (const comp of data.components) {
      const emoji = statusEmoji[comp.status];
      if (emoji !== undefined) {
        if (warns[emoji] === undefined) {
          warns[emoji] = `${emoji} ${comp.name.replace(/\s+/g, '')}`;
        } else {
          warns[emoji] += `,${comp.name.replace(/\s+/g, '')}`;
        }
      }
    }

    const warnsStr = Object.values(warns).sort().join(' ');
    return warnsStr.length
      ? {
          status: CheckerStatus.warn,
          title: `Github Status (Service degraded)`,
          message: warnsStr,
          link: `https://www.githubstatus.com/`,
        }
      : {
          status: CheckerStatus.ok,
          title: `Github Status`,
          message: `All components operational`,
        };
  }
}
